import React, { useEffect, useState } from 'react';
import { useApp } from '../context/AppContext';
import { motion } from 'framer-motion';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export const AboutPage = () => {
  const { t, language } = useApp();
  const [content, setContent] = useState(null);

  useEffect(() => {
    fetchContent();
  }, []);

  const fetchContent = async () => {
    try {
      const { data } = await axios.get(`${BACKEND_URL}/api/about`);
      setContent(data);
    } catch (error) {
      console.error('Failed to fetch about content');
    }
  };

  const getTranslatedText = (textObj) => {
    return textObj?.[language] || textObj?.en || '';
  };

  return (
    <div data-testid="about-page" className="min-h-screen pt-32 pb-24">
      <div className="container mx-auto px-6">
        <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }}>
          <h1 className="text-4xl md:text-5xl font-serif tracking-tight mb-12">
            {content ? getTranslatedText(content.title) : t('about')}
          </h1>

          {content?.image_url && (
            <div className="mb-12">
              <img src={content.image_url} alt="About" className="w-full h-96 object-cover" />
            </div>
          )}

          <div className="prose prose-invert prose-lg max-w-none">
            <p className="text-lg leading-relaxed text-muted-foreground whitespace-pre-line">
              {content ? getTranslatedText(content.content) : ''}
            </p>
          </div>
        </motion.div>
      </div>
    </div>
  );
};

export default AboutPage;